export const isBase64DataURL = (str) => {
    return /^data:(image|application)\/[a-zA-Z]+;base64,/.test(str);
  }

export const convertToFile = async (Image, name) => {
  const imgType = Image.split(";base64")[0].split(":")[1];
  const ext = imgType.split("/")[1];
  const pImage = await urltoFile(Image, `${name}.${ext}`, imgType);
  return pImage;
};



export const converBaseFileToBuffer = (file) => {
  // Clean the base64 (remove prefix if present)
  const base64 = file.split(",")[1]; // removes "data:application/octet-stream;base64," part

  // Convert to binary
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let i = 0; i < byteCharacters.length; i += 1024) {
    const slice = byteCharacters.slice(i, i + 1024);
    const byteNumbers = new Array(slice.length);
    for (let j = 0; j < slice.length; j++) {
      byteNumbers[j] = slice.charCodeAt(j);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  // Create the blob
  const fbxBlob = new Blob(byteArrays, { type: "application/octet-stream" });

  // Optional: create a File object if you want to mimic an uploaded file
  const fbxImage = new File([fbxBlob], "model.fbx", {
    type: "application/octet-stream",
  });
  return fbxImage;
};

const urltoFile = (url, filename, mimeType) => {
  if (url.startsWith("data:")) {
    const arr = url.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[arr.length - 1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file = new File([u8arr], filename, { type: mime || mimeType });
    return Promise.resolve(file);
  }
  return fetch(url)
    .then((res) => res.arrayBuffer())
    .then((buf) => new File([buf], filename, { type: mimeType }));
};

export const convertBase64 = (file) => {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  return new Promise((resolve) => {
    reader.onload = function () {
      resolve(reader.result);
    };
  });
  // reader.onerror = function (error) {
  //     console.log('Error: ', error);
  // };
};
